import { useState } from "react";

const DEFAULT_PREFERENCES = {
  arabic: { show: true },
  translation: { show: true },
  reference: { show: true },
};

const usePreferences = () => {
  const getStoredPreferences = () => {
    return (
      JSON.parse(localStorage.getItem("userPreferences")) || DEFAULT_PREFERENCES
    );
  };

  const [preferences, setPreferences] = useState(getStoredPreferences);

  const updatePreference = (category, key, value) => {
    const newPreferences = {
      ...preferences,
      [category]: { ...preferences[category], [key]: value },
    };

    setPreferences(newPreferences); // Update state
    localStorage.setItem("userPreferences", JSON.stringify(newPreferences));

    // Force trigger storage event
    window.dispatchEvent(new Event("storage"));
  };

  return { preferences, updatePreference };
};

export default usePreferences;
